import mapboxgl from "mapbox-gl";

export const createPopup = (title: string): mapboxgl.Popup => {
	return new mapboxgl.Popup({
		closeButton: true,
		closeOnClick: false,
		className: "personal-space-popup",
	}).setHTML(`
    <div class="popup-content">
      <h3>${title}</h3>
      <div class="popup-actions">
        <button class="popup-btn edit-btn">Edit</button>
        <button class="popup-btn delete-btn">Delete</button>
      </div>
    </div>
  `);
};

export const updatePopupContent = (
	popup: mapboxgl.Popup,
	content: string
): void => {
	popup.setHTML(content);
};

export const createInfoPopup = (
	map: mapboxgl.Map,
	lngLat: mapboxgl.LngLat,
	content: string
): mapboxgl.Popup => {
	return new mapboxgl.Popup({
		closeButton: true,
		closeOnClick: true,
		className: "info-popup",
	})
		.setLngLat(lngLat)
		.setHTML(content)
		.addTo(map);
};
